


export class CN47N {
  "network";
  "activity";
  "activityDesc";
  "workCenter";
  "activityType";
  "controlKey";
  "status";
  "companyCode";
  "transacaoOrigem";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CN47N`.
   */
  static getModelName() {
    return "CN47N";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CN47N for dynamic purposes.
  **/
  static factory(data) {
    return new CN47N(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CN47N',
      plural: 'CN47Ns',
      path: 'CN47Ns',
      properties: {
        "network": {
          name: 'network',
          type: 'string'
        },
        "activity": {
          name: 'activity',
          type: 'string'
        },
        "activityDesc": {
          name: 'activityDesc',
          type: 'string'
        },
        "workCenter": {
          name: 'workCenter',
          type: 'string'
        },
        "activityType": {
          name: 'activityType',
          type: 'string'
        },
        "controlKey": {
          name: 'controlKey',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "transacaoOrigem": {
          name: 'transacaoOrigem',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CN47N.js